import { Box, Divider, Grid } from '@mui/material';
import Utils from '../../../utils/Utils';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';
import SubBlockTextData from './SubBlockTextData';

interface SubBlockTextProps {
  data: SubBlockTextData;
  isEditing: boolean;
  isTemplate: boolean;
  onTitleUpdate: (text: string) => void;
  onTextUpdate: (text: string) => void;
  onSubBlockDelete: () => void;
  onTitleDelete: () => void;
  onTextDelete: () => void;
}

function SubBlockText({
  data,
  isEditing,
  isTemplate,
  onTitleUpdate,
  onTextUpdate,
  onSubBlockDelete,
  onTitleDelete,
  onTextDelete,
}: SubBlockTextProps) {
  return (
    <Grid
      item
      alignItems="center"
      justifyContent="center"
      sx={[
        Utils.hoverBorder(isEditing),
        {
          padding: 3,
          position: 'relative',
          margin: 1,
          marginBottom: 2,
          border: isEditing ? '1px dashed lightGray' : '1px solid #FFFFFF00',
        },
      ]}
    >
      <CloseButton
        show={isEditing}
        updateHandler={onSubBlockDelete}
      />

      {data.title.value ? (
        <Box sx={[Utils.hoverBorder(isEditing), { width: '100%' }]}>
          <EditableText
            text={data.title.value}
            textColor={data.title.settings?.textColor}
            isEditable={isEditing && !isTemplate}
            updateHandler={onTitleUpdate}
          />

          <Divider />

          <CloseButton
            show={isEditing}
            updateHandler={onTitleDelete}
          />
        </Box>
      ) : null}

      {data.text.value ? (
        <Box sx={[Utils.hoverBorder(isEditing), { width: '100%', marginTop: data.title.value ? 2 : 0 }]}>
          <EditableText
            text={data.text.value}
            textColor={data.text.settings?.textColor}
            isEditable={isEditing && !isTemplate}
            updateHandler={onTextUpdate}
          />

          <CloseButton
            show={isEditing}
            updateHandler={onTextDelete}
          />
        </Box>
      ) : null}
    </Grid>
  );
}

export default SubBlockText;
